import { createFileRoute, Outlet, redirect } from "@tanstack/react-router"
import { createServerFn } from "@tanstack/react-start"

import { AdminHeader } from "@/admin/admin-header"

const getAdminAuthContext = createServerFn({ method: "GET" }).handler(
  async () => {
    const { resolveAuthContext } = await import("@/lib/supabase/auth")
    return resolveAuthContext()
  }
)

export const Route = createFileRoute("/_admin")({
  beforeLoad: async () => {
    const authContext = await getAdminAuthContext()
    if (!authContext.user || authContext.userType !== "admin") {
      throw redirect({ to: "/login" })
    }
  },
  component: AdminLayout,
})

function AdminLayout() {
  return (
    <div>
      <AdminHeader />
      <div className="px-6 pt-32">
        <Outlet />
      </div>
    </div>
  )
}
